$(function() {
    function updateSelections(group) {
        var container = $('.js-quick-filter-selections[data-group='+group+']');
        var clear = $('.js-quick-filter-clear[data-group='+group+']');
        var others = $('.js-quick-filter[data-group='+group+']');

        container.empty();

        others.each(function() {
            if ($(this).prop('checked')) {
                var selection = '<span class="filterable__selection">'
                + '<label for="'+$(this).attr('id')+'" class="filterable__remove">×</label>'
                + ' ' + $(this).data('label');
                + '</span>';
                container.append(selection);
            }
        });

        if (!container.children().length) {
            container.hide();
            clear.hide();
        } else {
            container.css('display', 'inline-block');
            clear.css('display', 'inline-block');
        }
    }

    $('.js-quick-filter-clear').on('click', function(e) {
        e.preventDefault();
        var group = $(this).data('group');
        var others = $('.js-quick-filter[data-group='+group+']');

        others.each(function() {
            $(this).prop('checked', false);
            $(this).trigger('change');
        });
    });

    $('.js-quick-filter').change(function(e) {
        var target = $(this).data('target');
        var prop = $(this).data('prop');
        var group = $(this).data('group');
        var others = $('.js-quick-filter[data-group='+group+']');

        var vals = [];

        others.each(function() {
            if ($(this).prop('checked')) {
                vals.push($(this).val());
            }
        });

        if ($(this).data('type') == 'all') {
            if ($(this).prop('checked')) {
                $(target).show();
                others.not("[data-type=all]").prop('checked', false);
            } else {
                $(this).prop('checked', true);
            }
        } else if (!vals.length) {
            others.filter("[data-type=all]").prop('checked', true);
            $(target).show();
        } else {
            $(target).hide();

            if ($(this).prop('checked')) {
                others.filter("[data-type=all]").prop('checked', false);
            }

            $(target).each(function() {
                var items = $(this).data(prop);
                for (var index = 0; index < vals.length; index++) {
                    if ($.inArray(vals[index], items) > 0) {
                        $(this).show();
                    }
                }
            });
        }

        updateSelections(group);
    });
});
